<div class="selector-ejercicios">
    <div class="d-flex align-items-end flex-wrap gap-2 mb-2">
        <div class="flex-grow-1" style="min-width: 8rem;">
            <label class="form-label" for="ejercicios-busqueda">Ejercicios</label>
            <input id="ejercicios-busqueda" type="search" class="form-control" placeholder="Buscar año" autocomplete="off"
                data-testid="ejercicios-busqueda" [(ngModel)]="texto" [disabled]="deshabilitado">
        </div>
        <button type="button" class="btn btn-outline-secondary" data-testid="ejercicios-orden" [disabled]="deshabilitado" (click)="masRecientesPrimero = !masRecientesPrimero">
            <i class="bi bi-arrow-down-up" aria-hidden="true"></i>{{ masRecientesPrimero ? 'Más recientes primero' : 'Más antiguos primero' }}
        </button>
    </div>
    <div class="range-row mb-2">
        <span class="small text-muted">Rango:</span>
        <input type="number" class="form-control form-control-sm range-input" placeholder="Desde" aria-label="Desde el año" data-testid="ejercicios-desde" [(ngModel)]="desde" [disabled]="deshabilitado">
        <input type="number" class="form-control form-control-sm range-input" placeholder="Hasta" aria-label="Hasta el año" data-testid="ejercicios-hasta" [(ngModel)]="hasta" [disabled]="deshabilitado">
        <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="ejercicios-rango" [disabled]="deshabilitado || desde === null || hasta === null" (click)="anadirRango()">Añadir rango</button>
        <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="ejercicios-todos" [disabled]="deshabilitado" (click)="seleccionarVisibles()">Seleccionar los visibles</button>
        <button type="button" class="btn btn-link btn-sm p-0" data-testid="ejercicios-limpiar" [disabled]="deshabilitado || !seleccion.length" (click)="limpiar()">Quitar todos</button>
    </div>

    @if (cargando) {
        <p class="small text-muted" role="status" data-testid="ejercicios-cargando">Cargando ejercicios…</p>
    } @else if (error) {
        <div class="alert alert-danger py-2 d-flex justify-content-between align-items-center" role="alert" data-testid="ejercicios-error">
            <span>{{ error }}</span>
            <button type="button" class="btn btn-outline-danger btn-sm" data-testid="ejercicios-reintentar" (click)="reintentar.emit()">Reintentar</button>
        </div>
    } @else {
        <div class="year-picker" role="group" aria-label="Ejercicios" tabindex="0">
            @for (e of visibles; track e.id) {
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" [id]="'ejercicio-' + e.id" data-testid="ejercicio-casilla"
                        [checked]="estaSeleccionado(e.id)" [disabled]="deshabilitado" (change)="alternar(e.id)">
                    <label class="form-check-label" [for]="'ejercicio-' + e.id">
                        {{ e.anyo }}@if (e.vigente) { <span class="badge text-bg-primary ms-1" data-testid="ejercicio-vigente">vigente</span> }
                    </label>
                </div>
            } @empty {
                <p class="small text-muted mb-0" data-testid="ejercicios-vacio">No hay ejercicios que coincidan.</p>
            }
        </div>
        <p class="small mt-2 mb-0 selection-summary" aria-live="polite" data-testid="ejercicios-resumen">
            <strong>{{ seleccion.length }}</strong> seleccionado(s)@if (seleccion.length) { : {{ resumen }} }
        </p>
    }
</div>
